import React from "react";

import { Trans } from "react-i18next";
import i18next from "i18next";

import {
  Classes,
  Tag,
  Button,
  Dialog,
  Icon,
  Spinner,
  Callout,
  HTMLTable,
} from "@blueprintjs/core";

import {
  authenticatedGetFetch,
  authenticatedPutFetch,
} from "../../../utils/AuthenticatedFetch";
import { parkLookup } from "../../Structure/ParkSelector";
import { mefMontant, userIcons } from "../../../utils/mef";
import PlateImage from "../ALPR/PlateImage";

export default class SubscriberManagement extends React.Component {
  constructor() {
    super();
    this.state = {
      requestWait: false,
      dataWait: true,
      parkLookup: parkLookup(),
      deviceLookup: JSON.parse(localStorage.getItem("deviceLookup") || "{}"),
    };
  }

  componentDidMount() {
    authenticatedGetFetch(
      "/subscriber/" + this.props.id + "?srv=" + this.props.server,
      (response) => {
        this.setState({ ...response, dataWait: false });
      },
      null,
      null,
      () => {
        this.setState({ dataWait: false });
      }
    );
  }

  render() {
    return (
      <Dialog
        title={
          <span>
            <Trans>subscriber</Trans>{" "}
            <b>n°{this.state.NUMEABON || this.props.id}</b>
          </span>
        }
        isOpen={this.props.id !== undefined}
        canEscapeKeyCancel={true}
        canOutsideClickCancel={true}
        icon={userIcons[2]}
        onClose={() => {
          if (this.props.onClose !== undefined) this.props.onClose();
        }}
        onCancel={() => {
          if (this.props.onClose !== undefined) this.props.onClose();
        }}
      >
        {/*  
        UNUSED FIELDS:
          "NOMPORTE":"ROBERT"
          "NUMECATE":3,
          "SUPPOEXT":"",
          "DATEINTE":"20201231",
          "DMVTEQUI":61
          "DATEENTP":"202201131811",
          "DATEENSP":"",
          "IMMATRIC":"","IMMATRI2":"","IMMATRI3":"","IMMATRI4":"",
          "LISTPK":"8000000000000000000000000"
      */}
        {this.state.dataWait ? (
          <Spinner />
        ) : (
          <>
            {this.state.PRESENCE === undefined ? (
              <Callout
                key={"img"}
                intent="warning"
                title={
                  <span>
                    <Trans>subscriber</Trans>{" "}
                    <Trans>not found on the server</Trans>
                  </span>
                }
              >
                <p>
                  <Trans>can't retreive data</Trans>
                </p>
                <p>
                  <Trans>
                    the contract can be purged according to the server settings
                  </Trans>
                </p>
                <div className="flexbox-center">
                  <Icon icon="unknown-vehicle" size="100" />
                </div>
              </Callout>
            ) : (
              <span>
                <ul>
                  {this.state.PRESENCE !== undefined && this.state.PRESENCE ? (
                    <li>
                      <Trans>parking state:</Trans>
                      <Tag intent="primary">
                        {this.props.server + "_" + this.state.DMVTPARC}
                        <Trans>present in park</Trans> n°
                        {
                          this.state.parkLookup[
                            this.props.server + "_" + this.state.DMVTPARC
                          ]
                        }{" "}
                        <br /> <Trans>since</Trans>{" "}
                        {new Date(this.state.DMVTDATE).toLocaleString(
                          i18next.language
                        )}
                      </Tag>
                    </li>
                  ) : (
                    <li>
                      <Trans>parking state:</Trans>
                      <Tag intent="primary">
                        <Trans>not present</Trans>
                      </Tag>
                    </li>
                  )}
                  <li>
                    {Date.now() > new Date(this.state.VALIDDEB).getTime() &&
                    Date.now() < new Date(this.state.VALIDFIN).getTime() ? (
                      <Icon icon="tick" intent="success" />
                    ) : (
                      <Icon icon="cross" intent="danger" />
                    )}
                    <Trans>subscription valid</Trans> <Trans>from</Trans>{" "}
                    {new Date(this.state.VALIDDEB).toLocaleDateString(
                      i18next.language
                    )}{" "}
                    <Trans>to</Trans>{" "}
                    {new Date(this.state.VALIDFIN).toLocaleDateString(
                      i18next.language
                    )}{" "}
                    <Trans>on park</Trans>{" "}
                    {
                      this.state.parkLookup[
                        this.props.server + "_" + this.state.NUMEPARC
                      ]
                    }
                  </li>
                  <li>
                    {this.state.INTERDIC !== undefined &&
                    this.state.INTERDIC ? (
                      <Icon icon="cross" intent="danger" />
                    ) : (
                      <span>
                        <Icon icon="tick" intent="success" /> <Trans>not</Trans>{" "}
                      </span>
                    )}
                    <Trans>forbidden</Trans>
                  </li>
                  <li>
                    {this.state.INTERRUP !== undefined &&
                    this.state.INTERRUP ? (
                      <Icon icon="cross" intent="danger" />
                    ) : (
                      <span>
                        <Icon icon="tick" intent="success" /> <Trans>not</Trans>{" "}
                      </span>
                    )}{" "}
                    <Trans>interrupted</Trans>{" "}
                  </li>
                  <li>
                    {this.state.SURVEILL !== undefined &&
                    this.state.SURVEILL ? (
                      <Icon icon="cross" intent="warning" />
                    ) : (
                      <span>
                        <Icon icon="tick" intent="success" /> <Trans>not</Trans>{" "}
                      </span>
                    )}{" "}
                    <Trans>monitored</Trans>
                  </li>
                </ul>
                <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                  {this.state.PRESENCE !== undefined && this.state.PRESENCE ? (
                    <Button
                      loading={this.state.requestWait}
                      icon="following"
                      text={<Trans>set absent</Trans>}
                      onClick={() => {
                        authenticatedPutFetch(
                          "/subscriber/" +
                            this.state.NUMEABON +
                            "?srv=" +
                            this.props.server,
                          { presence: false },
                          () => {
                            this.setState(
                              { requestWait: true },
                              () =>
                                setTimeout(
                                  () =>
                                    authenticatedGetFetch(
                                      "/subscriber/" +
                                        this.props.id +
                                        "?srv=" +
                                        this.props.server,
                                      (response) => {
                                        this.setState({
                                          ...response,
                                          requestWait: false,
                                        });
                                      }
                                    ),
                                  1000
                                ) // PGEQ can take time to update the table
                            );
                          }
                        );
                      }}
                    />
                  ) : (
                    <Button
                      loading={this.state.requestWait}
                      icon="follower"
                      text={<Trans>set present</Trans>}
                      onClick={() => {
                        authenticatedPutFetch(
                          "/subscriber/" +
                            this.state.NUMEABON +
                            "?srv=" +
                            this.props.server,
                          { presence: true },
                          () => {
                            this.setState(
                              { requestWait: true },
                              () =>
                                setTimeout(
                                  () =>
                                    authenticatedGetFetch(
                                      "/subscriber/" +
                                        this.props.id +
                                        "?srv=" +
                                        this.props.server,
                                      (response) => {
                                        this.setState({
                                          ...response,
                                          requestWait: false,
                                        });
                                      }
                                    ),
                                  1000
                                ) // PGEQ can take time to update the table
                            );
                          }
                        );
                      }}
                    />
                  )}
                </div>
              </span>
            )}
            {this.state.events && this.state.events.length > 0 && (
              <Callout title={<Trans>event history</Trans>} icon="history">
                <HTMLTable striped={true} compact={true}>
                  <tbody>
                    {this.state.events.map((event) => (
                      <tr key={event.ID}>
                        <td>
                          {new Date(event.DAYEVEN).toLocaleString(
                            i18next.language
                          )}
                        </td>
                        <td>
                          {event.event !== undefined &&
                            event.event !== null && (
                              <Tag intent={event.event.intent}>
                                <Trans>{"event" + event.event.id}</Trans>
                              </Tag>
                            )}
                          {event.IMMAT && (
                            <>
                              <br />
                              <PlateImage
                                key="imm"
                                park={event.NUMEPARC}
                                plate={event.IMMAT}
                                date={event.DAYEVEN}
                                device={event.NUMEEQUI}
                                server={event?.sync?.syncServerId}
                              />
                            </>
                          )}
                        </td>
                        <td>
                          <Tag>
                            {this.state.parkLookup[
                              this.props.server + "_" + event.NUMEPARC
                            ] || this.state.parkLookup[event.NUMEPARC]}
                          </Tag>
                          <br />
                          <Tag>
                            {this.state.deviceLookup[
                              this.props.server + "_" + event.NUMEEQUI
                            ] || this.state.deviceLookup[event.NUMEEQUI]}
                          </Tag>
                        </td>
                        <td>
                          {event?.MONTSTAT > 0 && mefMontant(event.MONTSTAT)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </HTMLTable>
              </Callout>
            )}
          </>
        )}
      </Dialog>
    );
  }
}
